import React from "react";
import { Container, Typography, Box, Link } from "@mui/material";

export default function Foreword({ introText }) {
  return (
    <Container
      maxWidth="md"
      sx={{ p: 2, minHeight: { xs: "670px", md: "860px" } }}
    >
      <Box sx={{ px: { xs: 2, md: 5 }, pt: 8, pb: { xs: 5, md: 10 } }}>
        {/* Foreword Title */}
        <Typography
          variant="h3"
          align="center"
          fontWeight="bold"
          gutterBottom
          sx={{ mb: 2 }}
        >
          Foreword
        </Typography>
        <Box mb={4}>
          <div dangerouslySetInnerHTML={{ __html: introText }} />
        </Box>

        {/* Introduction */}
        {/* <Box mb={4} sx={{ textAlign: { xs: "justify", sm: "left" } }}>
          <Typography variant="body1" sx={{ mb: 2, color: "#767676" }}>
            Hi John,
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: "#767676" }}>
            It's easy to look at month-end reports and see how your campaign
            performed.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: "#767676" }}>
            But what about the opportunities you're missing? If you knew what to
            do to identify what's working and what isn't, improve your landing
            page design and convert more traffic into leads or sales... Wouldn't
            it make sense to do it?
          </Typography>
        </Box> */}

        {/* Main Content */}
        {/* <Box mb={4} sx={{ textAlign: { xs: "justify", sm: "left" } }}>
          <Typography variant="body1" sx={{ mb: 2, color: "#767676" }}>
            This landing page report measures everything that matters to ensure
            you get the best return on investment (ROI) on every click you send
            to your landing pages.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: "#767676" }}>
            In other words, it's all you need to make more strategic decisions
            to grow your business.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: "#767676" }}>
            You can use this report to quickly and efficiently evaluate your
            landing page strengths and weaknesses—in dozens of different ways.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: "#767676" }}>
            The prioritized recommendations you'll find here are easy to read
            and understand, so you can make smart decisions about where to
            allocate your precious time and resources to gain a competitive edge
            and a better return on your advertising budget.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: "#767676" }}>
            Stop guessing about what's wrong with your landing pages—and read
            this comprehensive, jargon-free landing page report instead.
          </Typography>
        </Box> */}

        {/* Report Structure */}
        {/* <Box mb={4} sx={{ textAlign: { xs: "justify", sm: "left" } }}>
          <Typography
            variant="h5"
            fontWeight="bold"
            gutterBottom
            sx={{
              mb: 2,
              color: "#767676",
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            Report structure
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: "#767676" }}>
            This report has been divided into different categories—from user
            experience and conversion optimization to page performance and
            security.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: "#767676" }}>
            The good news is we've compiled the most important and actionable
            items you need to help your business succeed online. Explanations
            are detailed but easy to read and understand.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: "#767676" }}>
            If you have any questions or need professional assistance to help
            you accomplish any of the recommendations in this document, we'd
            love to hear from you at{" "}
            <Link href="mailto:mm@youragency.com" sx={{ color: "#767676" }}>
              mm@youragency.com
            </Link>{" "}
            or (602) 123-4567.
          </Typography>
        </Box> */}

        {/* Footer */}
        {/* <Typography
          variant="body1"
          align="left"
          sx={{ mb: 2, color: "#767676" }}
        >
          Cheers,
          <br />
          Michael
        </Typography> */}
      </Box>
    </Container>
  );
}
